export const ENVIRONMENTS = {
	DEV: 'dev',
	TEST: 'test',
	ACCEPT: 'accept',
	STAGING: 'staging',
	PRODUCTION: 'production',
	LOCAL: 'local',
};
